
<div class="amplify-container" *ngIf="_show">
  <div class="amplify-form-container" data-test="sign-up-section">
    <div class="amplify-form-body" data-test="sign-up-body-section">
      <div
        class="amplify-form-header"
        data-test="sign-up-header-section"
        >{{ this.amplifyService.i18n().get(this.header) }}</div>
      <div class="amplify-form-row" *ngFor="let field of signUpFields">
        <div *ngIf="field.key !== 'phone_number'">
          <label class="amplify-input-label">
            {{ this.amplifyService.i18n().get(field.label) }}
            <span *ngIf="field.required">*</span>
          </label>
          <input #{{field.key}}
            class="amplify-form-input"
            [ngClass]="{'amplify-input-invalid ': field.invalid}"
            type={{field.type}}
            [placeholder]="this.amplifyService.i18n().get(field.label)"
            [(ngModel)]="user[field.key]"
            name="field.key"
            data-test="sign-up-non-phone-number-input"
            />
            <div *ngIf="field.key === 'password'" class="amplify-form-extra-details">
              {{passwordPolicy}}
            </div>
        </div>
        <div *ngIf="field.key === 'phone_number'">
          <amplify-auth-phone-field-core
            [label]="field.label"
            [required]="field.required"
            [placeholder]="field.placeholder"
            [defaultCountryCode]="country_code"
            (phoneFieldChanged)="onPhoneFieldChanged($event)"
          ></amplify-auth-phone-field-core>
        </div>
      </div>
      <div class="amplify-form-actions">
        <div class="amplify-form-cell-left" *ngIf="!shouldHide('SignIn')">
          <div class="amplify-form-signup">
            {{ this.amplifyService.i18n().get('Have an account?') }}
            <a class="amplify-form-link" (click)="onSignIn()" data-test="sign-up-sign-in-link">
              {{ this.amplifyService.i18n().get('Sign in') }}
            </a>
          </div>
        </div>
        <div class="amplify-form-cell-right">
          <button class="amplify-form-button"
          (click)="onSignUp()"
          data-test="sign-up-create-account-button"
          >{{ this.amplifyService.i18n().get('Create Account') }}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>
</div>
